module.exports = __webpack_public_path__ + "img/green4.cb06a9e1.png";